import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    // profile
    email: null,
    userId: null,
    isAdmin: false,
    accessToken: null,
    // "Should show" dialogs
    showBenchmarkingTour: false,
    showInsightsTour: false,
    showProfileDialog: false,
    // "Has shown" dialogs
    benchmarkingTourShown: false,
    benchmarkingDialogShown: false,
    insightsTourShown: false,
    profileDialogShown: false,
    popupQuestionDialogShown: false,
    // "Is showning" dialogs
    isShowingBenchmarkingTour: false,
    isShowingBenchmarkingDialog: false,
    isShowingInsightsTour: false,
    isShowingProfileDialog: false,
    isShowingPopupQuestionDialog: false,
    // Misc
    profileComplete: false,
    profileResponsesLastUpdated: null

}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action) => {
            const { email, userId, isAdmin, accessToken, showBenchmarkingTour, showInsightsTour, profileComplete } = action.payload;
            state.email = email;
            state.userId = userId;
            state.isAdmin = isAdmin === true;
            state.accessToken = accessToken;
            if (showBenchmarkingTour !== undefined) {
                state.showBenchmarkingTour = showBenchmarkingTour === true;
            }
            if (showInsightsTour !== undefined) {
                state.showInsightsTour = showInsightsTour === true;
            }
            if (profileComplete !== undefined) {
                state.profileComplete = profileComplete === true;
                state.showProfileDialog = profileComplete === false;
            }
        },
        logOut: () => initialState,
        // "Has shown" dialogs
        setBenchmarkingTourShown: (state) => {
            state.benchmarkingTourShown = true;
        },
        setBenchmarkingDialogShown: (state) => {
            state.benchmarkingDialogShown = true;
        },
        setInsightsTourShown: (state) => {
            state.insightsTourShown = true;
        },
        setProfileDialogShown: (state) => {
            state.profileDialogShown = true;
        },
        setPopupQuestionDialogShown: (state) => {
            state.popupQuestionDialogShown = true;
        },
        // "Is showning" dialogs
        setIsShowingBenchmarkingTour: (state, action) => {
            state.isShowingBenchmarkingTour = action.payload === true;
        },
        setIsShowingBenchmarkingDialog: (state, action) => {
            state.isShowingBenchmarkingDialog = action.payload === true;
        },
        setIsShowingInsightsTour: (state, action) => {
            state.isShowingInsightsTour = action.payload === true;
        },
        setIsShowingProfileDialog: (state, action) => {
            state.isShowingProfileDialog = action.payload === true;
        },
        setIsShowingPopupQuestionDialog: (state, action) => {
            state.isShowingPopupQuestionDialog = action.payload === true;
        },
        // profile response update
        responsesUpdated: (state) => {
            state.responsesLastUpdated = (new Date()).getTime();
        },

    }
});

export const { setCredentials, logOut, setBenchmarkingTourShown, setBenchmarkingDialogShown, setInsightsTourShown, setProfileDialogShown, setPopupQuestionDialogShown, setIsShowingBenchmarkingTour, setIsShowingBenchmarkingDialog, setIsShowingInsightsTour, setIsShowingProfileDialog, setIsShowingPopupQuestionDialog, responsesUpdated } = authSlice.actions;

export default authSlice.reducer;

export const selectIsAdmin = (state) => (state.auth.isAdmin === true);
export const selectAccessToken = (state) => state.auth.accessToken;
export const selectCredentials = (state) => state.auth;
export const selectIsLoggedIn = (state) => (state.auth.email !== null);
// "Should show" dialogs
export const selectShowBenchmarkingTour = (state) => state.auth.showBenchmarkingTour;
export const selectShowInsightsTour = (state) => state.auth.showInsightsTour;
export const selectShowProfileDialog = (state) => state.auth.showProfileDialog;
// "Has shown" dialogs
export const selectBenchmarkingTourShown = (state) => state.auth.benchmarkingTourShown;
export const selectBenchmarkingDialogShown = (state) => state.auth.benchmarkingDialogShown;
export const selectInsightsTourShown = (state) => state.auth.insightsTourShown;
export const selectProfileDialogShown = (state) => state.auth.profileDialogShown;
export const selectPopupQuestionDialogShown = (state) => state.auth.popupQuestionDialogShown;
// "Is showing" dialogs
export const selectIsShowingBenchmarkingTour = (state) => state.auth.isShowingBenchmarkingTour;
export const selectIsShowingBenchmarkingDialog = (state) => state.auth.isShowingBenchmarkingDialog;
export const selectIsShowingInsightsTour = (state) => state.auth.isShowingInsightsTour;
export const selectIsShowingProfileDialog = (state) => state.auth.isShowingProfileDialog;
export const selectIsShowingPopupQuestionDialog = (state) => state.auth.isShowingPopupQuestionDialog;
export const selectCanShowPopupQuestionDialog = (state) => {
    return !(
        state.auth.isShowingBenchmarkingTour ||
        state.auth.isShowingBenchmarkingDialog ||
        state.auth.isShowingInsightsTour ||
        state.auth.isShowingProfileDialog ||
        state.auth.isShowingPopupQuestionDialog ||
        state.auth.popupQuestionDialogShown
    )
};
// Misc
export const selectProfileComplete = (state) => state.auth.profileComplete;
